<template>
  <div style="height: 79vh; overflow-y: scroll;">
    <section class="container-fluid">
      <div class="mt-3 mb-4" v-if="events.length > 0 && pastEvents.length > 0">
        <h5><b>Upcoming Scheduled Events</b></h5>
        <div class="data-scroll">
          <div class="row">
            <div
              class="col-12 col-sm-6 col-md-6 col-lg-4 mt-2 mb-2"
              v-for="(e, i) in events"
              :key="i"
            >
              <div class="card">
                <!--								<div class="row">-->
                <!--									<div class="col-5">-->
                <!--										<img v-if="e.image" :src="e.image" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 100%;">-->
                <!--										<img v-else src="../../assets/verify.png" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 100%;">-->
                <!--										<div class="bg-success" id="HST" v-if="e.role==='host'"><span style="margin-top: 6px">HST</span></div>-->
                <!--										<div class="bg-info" id="SPK" v-else-if="e.role==='speaker'"><span style="margin-top: 6px">SPK</span></div>-->
                <!--										<div class="bg-warning" id="ATT" v-else><span style="margin-top: 6px">ATT</span></div>-->
                <!--									</div>-->
                <!--									<div class="col-7">-->
                <!--										<h5 class="mb-0 mt-1">{{e.title.length >= 12 ? e.title.substr(0, 12) + '..' : e.title.toUpperCase()}}</h5>-->
                <!--										<p class="text-white mb-0" style="font-size: 12px;"  v-if="e.status === 'Live'" ><span class="bg-danger" style="border-radius: 2px;padding: 0 2px">Live</span></p>-->
                <!--										<p style="font-size: 12px" v-else class="text-muted mb-0">{{e.start_date | moment("from", "now")}}</p>-->
                <!--										<div style="margin-right: 5px; margin-bottom: 5px">-->
                <!--											<a :href="'https://meetbeans.com/e/' + e.event_id" target="_blank" class="btn btn-primary btn-sm">-->
                <!--												<b style="margin-right: 10px">Enter</b>-->
                <!--												<i class="fas fa-door-open"></i>-->
                <!--											</a>-->
                <!--											<a class="btn btn-secondary btn-sm" title="Calender" style="border-radius: 25px; margin-left: 2px;" target="_blank" :href="'https://calendar.google.com/calendar/r/eventedit?text='+ e.title +'&dates=' + e.calendar_start  +'/' + e.calendar_end +'&details=For+details,+link+here:+https://meetbeans.com/e/' + e.event_id + '&location=meetbeans.com'">-->
                <!--										<span>-->
                <!--											<i class="fas fa-calendar-week"></i>-->
                <!--										</span>-->
                <!--											</a>-->
                <!--										</div>-->
                <!--									</div>-->
                <!--								</div>-->
                <img
                  v-if="e.image"
                  :src="e.image"
                  style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 12px 0 0; width: 100%; height: 150px;"
                />
                <img
                  v-else
                  src="../../assets/verify.png"
                  style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 150px;"
                />
                <div class="bg-success" id="HST" v-if="e.role === 'host'">
                  <span style="margin-top: 6px;color: #000;">HST</span>
                </div>
                <div class="bg-info" id="SPK" v-else-if="e.role === 'speaker'">
                  <span style="margin-top: 6px">SPK</span>
                </div>
                <div class="bg-warning" id="ATT" v-else>
                  <span style="margin-top: 6px">ATT</span>
                </div>
                <div class="card-body">
                  <h5 class="mb-0 mt-1" style="font-family: 'Vidaloka', serif;">
                    {{
                      e.title.length >= 20
                        ? e.title.substr(0, 20) + ".."
                        : e.title
                    }}
                  </h5>
                  <p
                    class="text-white mb-0"
                    style="font-size: 12px;"
                    v-if="e.status === 'Live'"
                  >
                    <span
                      class="bg-danger"
                      style="border-radius: 2px;padding: 0 2px"
                      >Live</span
                    >
                  </p>
                  <p style="font-size: 12px" v-else class="text-muted mb-0">
                    {{ e.start_date | moment("from", "now") }}
                  </p>
                  <div style="margin-right: 5px; margin-bottom: 5px">
                    <a
                      :href="'/e/' + e.event_id"
                      target="_blank"
                      class="btn btn-primary btn-sm"
                    >
                      <b style="margin-right: 10px">Enter</b>
                      <i class="fas fa-door-open"></i>
                    </a>
                    <a
                      class="btn btn-secondary btn-sm"
                      title="Calender"
                      style="border-radius: 25px; margin-left: 2px;"
                      target="_blank"
                      :href="
                        'https://calendar.google.com/calendar/r/eventedit?text=' +
                          e.title +
                          '&dates=' +
                          e.calendar_start +
                          '/' +
                          e.calendar_end +
                          '&details=For+details,+link+here:+https://meetbeans.com/e/' +
                          e.event_id +
                          '&location=meetbeans.com'
                      "
                    >
                      <span>
                        <i class="fas fa-calendar-week"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="margin: 5%;"
        v-if="events.length === 0 && pastEvents.length === 0"
      >
        <div class="text-center">
          <svg
            width="250"
            height="250"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <image
              href="../../assets/balloon.svg"
              style="color: #fbaf28 !important;"
              width="250"
              height="250"
            />
          </svg>
          <p>
            Registered event will show up here, <br />
            so you can view them here later.
          </p>
        </div>
      </div>
    </section>
    <section
      id="pastEvents"
      class="container-fluid"
      v-if="pastEvents.length > 0"
    >
      <hr />
      <h5>Past Scheduled Events</h5>
      <div class="container">
        <v-timeline :align-top="false" :dense="isMobile" :reverse="true" dark>
          <v-timeline-item
            dark
            v-for="(p, i) in pastEvents"
            :key="i"
            color="#ffb229"
            fill-dot
          >
            <span slot="opposite"
              >{{ p.start_date | moment("MMMM Do YYYY") }} -
              {{ p.end_date | moment("MMMM Do YYYY") }}</span
            >
            <v-card class="elevation-2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1" style="font-weight: 800">{{
                    p.title
                  }}</v-list-item-title>
                </v-list-item-content>

              </v-list-item>
                <v-img max-width="200" max-height="150" :src="p.image" style="margin: 0 auto"></v-img>

              <v-card-actions>
                <a
                  :href="'https://meetbeans.com/e/' + p.event_id"
                  target="_blank"
                  class="btn btn-primary btn-sm"
                >
                  <b style="margin-right: 10px">View</b>
                  <i class="fas fa-eye"></i>
                </a>
              </v-card-actions>
            </v-card>
          </v-timeline-item>
        </v-timeline>
        <!-- <ul class="timeline" v-for="(p, i) in pastEvents" :key="i">
					<li v-if="i%2 === 0">
						<div class="timeline-panel">
							<div class="row">
								<div class="col-6">
									<img src="../../assets/verify.png" class="img-fluid" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 100%;">
								</div>
								<div class="col-6">
									<div style="padding: 20px 5px;">
										<h5 class="mb-0 mt-1">{{p.title}}</h5>
										<p style="font-size: 10px" class="text-muted">{{p.start_date | moment("MMMM Do YYYY")}} - {{p.end_date | moment("MMMM Do YYYY")}}</p>
										<a :href="'https://meetbeans.com/e/' + p.event_id" target="_blank" class="btn btn-primary btn-sm">
											<b style="margin-right: 10px">View</b>
											<i class="fas fa-eye"></i>
										</a>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li class="timeline-inverted" v-else>
						<div class="timeline-panel">
							<div class="row">
								<div class="col-6">
									<div style="padding: 20px 10px;">
										<h5 class="mb-0 mt-1">{{p.title}}</h5>
										<p style="font-size: 10px" class="text-muted">{{p.start_date | moment("MMMM Do YYYY")}} - {{p.end_date | moment("MMMM Do YYYY")}}</p>
										<a :href="'https://meetbeans.com/e/' + p.event_id" target="_blank" class="btn btn-primary btn-sm">
											<b style="margin-right: 10px">View</b>
											<i class="fas fa-eye"></i>
										</a>
									</div>
								</div>
								<div class="col-6">
									<img :src="p.image" class="img-fluid" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 0px 12px 12px 0px; width: 100%; height: 100%;">
								</div>
							</div>
						</div>
					</li>

				</ul> -->
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "dashboard",
  data() {
    return {
      windowWidth: window.innerWidth,
      tutorial: {
        title: "",
      },
      tutorials: [],
      user: { is_admin: false },
      upcomingEvents: [],
      teams: [],
      events: [],
      pastEvents: [],
      counter: {
        invited: 0,
        registered: 0,
        attended: 0,
        meetFast: 0,
      },
    };
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    if (this.user === null) {
      this.$router.push("/");
    }
    this.counters();
    this.eventList();
    this.getTutorials();
    this.pastEventsFunction();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 600;
    },
  },
  methods: {
    setTutorial(t) {
      this.tutorial = t;
    },
    closeTutorial() {
      this.tutorial = {
        title: "",
      };
    },
    dateTimeStamp(datePass) {
      var fullDate = new Date(datePass);
      var twoDigitMonth = fullDate.getUTCMonth() + "";
      if (twoDigitMonth.length == 1) twoDigitMonth = "0" + twoDigitMonth;
      var twoDigitDate = fullDate.getUTCDate() + "";
      if (twoDigitDate.length == 1) twoDigitDate = "0" + twoDigitDate;
      var twoDigithour = fullDate.getUTCHours() + "";
      if (twoDigithour.length == 1) twoDigithour = "0" + twoDigithour;
      var twoDigitMin = fullDate.getUTCMinutes() + "";
      if (twoDigitMin.length == 1) twoDigitMin = "0" + twoDigitMin;
      // var currentDate = fullDate.getFullYear() + twoDigitMonth.getMonth() + twoDigitDate.getDate() + "T" + fullDate.getHours() + fullDate.getMonth() +"00"+ "z";
      var currentDate =
        fullDate.getUTCFullYear() +
        "" +
        twoDigitMonth +
        "" +
        twoDigitDate +
        "T" +
        twoDigithour +
        twoDigitMin +
        "00" +
        "Z";

      // console.log(currentDate);
      return currentDate;
    },
    counters: function() {
      this.$store.dispatch("getUserCounter").then((resp) => {
        if (resp.data.status === "success") {
          this.counter = resp.data.data;
        }
      });
    },
    eventList: function() {
      this.$store.dispatch("getUpcomingEvent").then((resp) => {
        if (resp.data.status === "success") {
          this.events = resp.data.data;
          this.events.forEach((x) => {
            x.calendar_start = this.dateTimeStamp(
              x.start_date + " " + x.start_time
            );
            x.calendar_end = this.dateTimeStamp(x.end_date + " " + x.end_time);
          });
        }
      });
    },
    pastEventsFunction: function() {
      this.$store.dispatch("getPastEvents").then((resp) => {
        if (resp.data.status === "success") {
          this.pastEvents = resp.data.data.sort(function(a,b){
              return new Date(b.start_date) - new Date(a.start_date);
            });
          this.pastEvents.forEach((x) => {
            x.calendar_start = this.dateTimeStamp(
              x.start_date + " " + x.start_time
            );
            x.calendar_end = this.dateTimeStamp(x.end_date + " " + x.end_time);
          });
        }
      });
    },
    getTutorials: function() {
      this.$store.dispatch("getTutorials").then((resp) => {
        if (resp.data.status === "success") {
          this.tutorials = resp.data.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-timeline::before {
	right: 50%;
}
@media only screen and (max-device-width: 600px) {
	.v-timeline::before {
		right: 21%;	
	}
}

</style>
